/**
 * Makes sure all images get loaded in nicely
 *
 * @returns {void}
 */
export default prettyImageLoader = (() => {
    const images = document.querySelectorAll('img:not(.cart-item-thumbnail)');

    images.forEach((image) => {
        fadeInImage(image);
    });

    const imageMutationObserver = new MutationObserver((mutations, observer) => {
        for (const mutation of mutations) {
            let mutatedImages = [...mutation.target.querySelectorAll('img:not(.cart-item-thumbnail)')];

            if (mutatedImages.length > 0)
                mutatedImages.forEach((image) => {
                    fadeInImage(image);
                });
        }
    });

    document.addEventListener('DOMContentLoaded', () => {
        imageMutationObserver.observe(document.body, { childList: true, subtree: true });
    });
})();

/**
 * Fades images in nicely
 *
 * @param {HTMLImageElement} image
 * @returns {void}
 */
function fadeInImage(image) {
    if (image.complete) {
        image.classList.add('lv-loaded');
    } else {
        image.addEventListener(
            'load',
            () => {
                image.classList.add('lv-loaded');
            },
            { once: true }
        );
    }
}
